import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DeleteWarningIcon } from '../ui/icons'; // use your icon
import { useDeleteAlertusTokenModal } from './useDeleteAlertusTokenModal';

interface DeleteTokenModalProps {
  id: string;
  name: string;
}

const DeleteAlertusTokenModal: React.FC<DeleteTokenModalProps> = ({ id, name }) => {
  const { handleDeleteButtonClick, show, handleClose, handleShow } = useDeleteAlertusTokenModal(id);

  return (
    <>
      <div onClick={handleShow}>
        Delete
      </div>
      <Modal show={show} onHide={handleClose} className='modal-container disable-modal' centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className='delete-heading'>
              <DeleteWarningIcon />
              <h1>Delete Token</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete <strong>{show ? name : null}</strong> token?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='btn-delete' onClick={handleDeleteButtonClick}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteAlertusTokenModal;
